/**
 * Created by tayloremolo on 12/5/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Sponsors extends Component {

    render() {

        return (
            <div id="sponsors">
                <div className="white z-22">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-62 black-text bold-text text-uppercase mb0">Thank You To<br/><span className="f-84 ls-5 brand-text">Our Sponsors</span></h1>                                <br />

                            </div>


                            <div className="col s6 m3 center-align">
                                <a href="https://piloto151.com/ ">
                                    <img className="responsive-img" src="../static/p151.png" alt="sponsors"/>
                                </a>
                            </div>


                            <div className="col s6 m3  center-align">
                                <a href="https://www.parallel18.com">
                                    <img className="responsive-img" src="../static/p18.png" alt="sponsors"/>
                                </a>
                            </div>


                            <div className="col s6 m3  center-align">
                                <a href="https://www.fundacionbancopopular.org/en/">
                                    <img className="responsive-img" src="../static/bp.png" alt="sponsors"/>
                                </a>
                            </div>


                            <div className="col s6 m3  center-align">
                                <a href="https://www.prtrust.org/en/">
                                    <img className="responsive-img" src="../static/prtrust.png" alt="sponsors"/>
                                </a>
                            </div>


                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/e-logo-google.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/forbes.jpg" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <a href="https://sanglucci.com/">
                                    <img className="responsive-img" src="../static/Sang-Lucci-Logo.png" alt="sponsors"/>
                                </a>
                            </div>



                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/paul-logo.png" alt="sponsors"/>
                            </div>



                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/7logo.png" alt="sponsors"/>
                            </div>



                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/blockfinity.png" alt="sponsors"/>
                            </div>



                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/goldfingr.png" alt="sponsors"/>
                            </div>






                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/startupgrind.png" alt="sponsors"/>
                            </div>




                            <div className="col s6 m3  center-align">
                                <a href="https://pideuva.com/">
                                    <img className="responsive-img" src="../static/uva.png" alt="sponsors"/>
                                </a>
                            </div>


                            <div className="col s6 m3 center-align">
                                <a href="http://liquex.io/">
                                    <img className="responsive-img" src="../static/liquex.png" alt="sponsors"/>
                                </a>
                            </div>



                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/fownders-logo-new-1.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/crypto-monday.jpg" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/new-theory-logo-black-type-1.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/cropped-lnblogo.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/nyc-coin.jpg" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/Colmena-66.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/edublock.png" alt="sponsors"/>
                            </div>

                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/hustle-scale-logo-01.png" alt="sponsors"/>
                            </div>





                            <div className="col s6 m3 center-align">
                                <img className="responsive-img" src="../static/tell.png" alt="sponsors"/>
                            </div>



                            <div className="col s6 m3  center-align">
                                <img className="responsive-img" src="../static/e4.jpg" alt="sponsors"/>
                            </div>







                        </div>


                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <br/>
                                <br/>
                                <a href="https://goo.gl/forms/fOlr52OqpWh7vnlb2" target="_blank" className="btn-large orange brand-cta waves-effect waves-light">BECOME A SPONSOR</a>
                                <br/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )

    }

}

export default Sponsors;


// WEBPACK FOOTER //
// ./src/components/sponsors.js